import {
    ADS_GET_CONTACTS,
    ADS_CHANGE_CONTACT_STATUS,
    ADS_DELETE_CONTACT,
} from "../actions/ads";

import {
    API_BASE_URL,
    ADS_GET_CONTACTS_URL,
    ADS_CHANGE_CONTACT_STATUS_URL,
    ADS_DELETE_CONTACT_URL,
} from "../variables";

import axios from "axios";

const state = {};
const mutations = {};
const getters = {};
const actions = {
    [ADS_GET_CONTACTS]: ({ commit, state, getters }, payload) => {
        return axios({
            url: API_BASE_URL + ADS_GET_CONTACTS_URL,
            method: "POST",
            data: payload,
            headers: {
                'Authorization': 'Bearer ' + getters.getUserAccessToken,
            }
        });
    },
    [ADS_CHANGE_CONTACT_STATUS]: ({ commit, state, getters }, payload) => {
        return axios({
            url: API_BASE_URL + ADS_CHANGE_CONTACT_STATUS_URL,
            method: "POST",
            data: payload,
            headers: {
                'Authorization': 'Bearer ' + getters.getUserAccessToken,
            }
        });
    },
    [ADS_DELETE_CONTACT]: ({ commit, state, getters }, payload) => {
        return axios({
            url: API_BASE_URL + ADS_DELETE_CONTACT_URL,
            method: "POST",
            data: payload,
            headers: {
                'Authorization': 'Bearer ' + getters.getUserAccessToken,
            }
        });
    }
};


export default {
    mutations,
    actions,
    getters,
    state
};